import { render, staticRenderFns } from "./AProgramas.vue?vue&type=template&id=2364d03b"
import script from "./AProgramas.vue?vue&type=script&lang=js"
export * from "./AProgramas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports